module.exports = __webpack_public_path__ + "img/S9-4.12e32215.png";